import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { padding } from 'app/shared/styles/_spacing';
import { colors } from 'app/shared/styles/_colors';
import { inset, stacked } from 'app/shared/styles/_spacing';
import { viewports } from 'app/shared/styles/_breakpoints';

// Components
import LinkerBase from 'app/shared/modules/Linker';
import Text from 'app/shared/core/Text';

export const Footer = styled.footer<{ noMarginTop?: boolean }>`
  ${font.sm};
  background-color: ${colors['$hpx-blue-600']};
  color: ${colors['$hpx-white']};
  display: block;

  /* Mobile styles */
  ${(props) => (props.noMarginTop ? '' : padding.top._3x)};
  ${padding.right._2x};
  ${padding.bottom._3x};
  ${padding.left._2x};

  /* Desktop styles - match FooterNav */
  @media ${viewports['md-and-up']} {
    margin-top: ${(props) => (props.noMarginTop ? '0px' : '80px')};
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }
`;

export const FooterList = styled.ul`
  list-style: none;

  /* Mobile styles */
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  /* Desktop styles - match FooterNav inline layout */
  @media ${viewports['md-and-up']} {
    display: block;
    ${stacked._1x};
    ${padding.top._1x};
  }
`;

export const Li = styled.li`
  /* Mobile styles */
  ${inset._1x};
  font-weight: bold;

  /* Desktop styles - match FooterNav */
  @media ${viewports['md-and-up']} {
    display: inline;
    margin: 0 8px;
    padding: 0;
    font-weight: normal;
  }
`;

export const Linker = styled(LinkerBase)`
  &:focus {
    outline: -webkit-focus-ring-color auto 1px;
    outline-offset: 5px;
  }

  /* Desktop styles - match FooterNav */
  @media ${viewports['md-and-up']} {
    display: inline-block;
    line-height: 28px;
    width: inherit;
  }
`;

export const AppBadgeSection = styled.section`
  display: flex;
  justify-content: center;
  ${stacked._1x};

  /* Desktop styles - match FooterNav mobile-apps layout */
  @media ${viewports['md-and-up']} {
    ${stacked._1x};
    ${padding.top._1x};
  }
`;

export const BadgeImg = styled.img`
  /* Mobile styles */
  margin: 8px;

  /* Desktop styles - match FooterNav mobile-apps */
  @media ${viewports['md-and-up']} {
    width: 120px;
    display: inline-block;
    margin: 0;

    &:first-child {
      margin-right: 16px;
    }
  }
`;

export const Paragraph = styled.p`
  ${font.tiny};
  text-align: center;
  margin: 0; /* Remove default browser margins */

  /* Mobile styles */
  ${stacked._2x};

  /* Desktop styles - no spacing, handled by section containers */
  @media ${viewports['md-and-up']} {
    margin: 0;
  }
`;

export const CrossbrandNav = styled.nav`
  ${font.tiny};
  text-align: center;
  margin: 0; /* Remove default browser margins */

  /* Mobile styles */
  ${stacked._2x};

  /* Desktop styles - no spacing, handled by section containers */
  @media ${viewports['md-and-up']} {
    margin: 0;
  }
`;

export const HudImg = styled.img`
  ${padding.left._xs};

  /* Desktop styles - match FooterNav HUD icon */
  @media ${viewports['md-and-up']} {
    vertical-align: text-bottom;
  }
`;

// Desktop section containers to match FooterNav structure
export const TextSection = styled.section`
  /* Mobile styles */
  display: contents;

  /* Desktop styles - match StyledTextSection */
  @media ${viewports['md-and-up']} {
    ${stacked._xs};
    ${padding.top._1x};
  }
`;

export const FairHousingTextSection = styled.section`
  /* Mobile styles */
  display: contents;

  /* Desktop styles - add extra top margin for Fair Housing section */
  @media ${viewports['md-and-up']} {
    ${stacked._xs};
    ${padding.top._2x}; /* Increased from _1x to _2x for more top margin */
  }
`;

export const FairHousingSection = styled.section`
  /* Mobile styles */
  display: contents;

  /* Desktop styles - match StyledFairHousingSection (no padding-top) + bottom margin */
  @media ${viewports['md-and-up']} {
    ${stacked._1x};
    margin-bottom: 16px; /* Add bottom margin below Fair Housing Guide */
  }
`;

export const HotPadsSection = styled.section`
  /* Mobile styles */
  display: contents;

  /* Desktop styles - match StyledHotPadsSectionContainer */
  @media ${viewports['md-and-up']} {
    ${stacked._1x};
    ${padding.top._1x};
  }
`;

// Styled Text component for Footer text sections
export const FooterText = styled(Text)`
  /* Mobile styles - block display and centered */
  display: block;
  text-align: center;
  ${stacked._2x};

  /* Desktop styles - no extra spacing, handled by section containers */
  @media ${viewports['md-and-up']} {
    margin: 0;
  }
`;
